import { defineMessages } from 'react-intl';

export default defineMessages({
  areYouClaimingForDamaged: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingForDamaged',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },
  areYouClaimingForBaggageDelay: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },
  travelSupplierOrProviderInformation: {
    id: 'fastCover.BaggagePersonalEffects.travelSupplierOrProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  nameOfTourOperatorOrCruiseOrLineOrAirline: {
    id: 'fastCover.BaggagePersonalEffects.travelSupplierOrProviderInformation',
    defaultMessage: 'Name of Tour Operator/Cruise Line/Airline you were traveling with:',
  },
  origination: {
    id: 'fastCover.BaggagePersonalEffects.origination',
    defaultMessage: 'Origination',
  },

  flightNumber: {
    id: 'fastCover.BaggagePersonalEffects.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.BaggagePersonalEffects.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.BaggagePersonalEffects.destination',
    defaultMessage: 'Destination',
  },
  sectionTitle: {
    id: 'fastCover.BaggagePersonalEffects.sectionTitle',
    defaultMessage:
      'Section 4 - Damaged, Lost or Stolen Luggage, Travel Documents or Cash',
  },
  yes: {
    id: 'fastCover.BaggagePersonalEffects.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.BaggagePersonalEffects.no',
    defaultMessage: 'No',
  },
  areYouClaimingForLossTheftOrDamageTo: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingForLossTheftOrDamageTo',
    defaultMessage: 'Are you claiming for Loss, Theft or Damage to:',
  },
  passportsCreditCards: {
    id: 'fastCover.BaggagePersonalEffects.passportsCreditCards',
    defaultMessage: 'Passports, Credit Cards & Credit Card Fraud?',
  },
  theftOfCash: {
    id: 'fastCover.BaggagePersonalEffects.theftOfCash',
    defaultMessage: 'Theft of Cash',
  },
  luggageAndPersonalEffects: {
    id: 'fastCover.BaggagePersonalEffects.luggageAndPersonalEffects',
    defaultMessage: 'Luggage and Personal Items',
  },
  luggageInclude: {
    id: 'fastCover.BaggagePersonalEffects.luggageInclude',
    defaultMessage:
      'Luggage includes your bags, clothes, devices and other personal belongings.',
  },
  toAssistYourClaim: {
    id: 'fastCover.BaggagePersonalEffects.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.BaggagePersonalEffects.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.BaggagePersonalEffects.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.BaggagePersonalEffects.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.BaggagePersonalEffects.document1',
    defaultMessage:
      'Police report or written report from a relevant authority or Travel Provider (Airline, hotel, Cruise Liner, Tour Company etc.)',
  },
  document2: {
    id: 'fastCover.BaggagePersonalEffects.document2',
    defaultMessage: 'Damage or Repair report',
  },
  document3: {
    id: 'fastCover.BaggagePersonalEffects.document3',
    defaultMessage: 'Quote for repair or replacement',
  },
  document4: {
    id: 'fastCover.BaggagePersonalEffects.document4',
    defaultMessage:
      'Purchase receipt or other Evidence of Ownership for each item claimed',
  },
  document5: {
    id: 'fastCover.BaggagePersonalEffects.document5',
    defaultMessage:
      "For all losses or delays caused by your Transport Provider, a 'Property Irregularity Report' from the Transport Provider",
  },
  document6: {
    id: 'fastCover.BaggagePersonalEffects.document6',
    defaultMessage:
      'Written evidence from the Transport Provider confirming the days and hours your luggage was delayed and the time that it was returned to you',
  },
  document7: {
    id: 'fastCover.BaggagePersonalEffects.document7',
    defaultMessage: 'Receipts for essential clothing and toiletries purchased',
  },
  document8: {
    id: 'fastCover.BaggagePersonalEffects.document8',
    defaultMessage:
      'For Cash claims, Bank or Credit Card statements or ATM or Currency Conversion receipts showing withdrawal of funds',
  },
  document9: {
    id: 'fastCover.BaggagePersonalEffects.document9',
    defaultMessage:
      'For mobile phone claims please block the IMEI letter with your network provider',
  },
  provideExplanation: {
    id: 'fastCover.BaggagePersonalEffects.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  luggageWasLostStolenOrDamaged: {
    id: 'fastCover.BaggagePersonalEffects.luggageWasLostStolenOrDamaged',
    defaultMessage:
      'If your luggage was lost, stolen or damaged please tell us:',
  },
  howItHappened: {
    id: 'fastCover.BaggagePersonalEffects.howItHappened',
    defaultMessage: '1. How it happened',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.BaggagePersonalEffects.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.BaggagePersonalEffects.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.BaggagePersonalEffects.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.BaggagePersonalEffects.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.BaggagePersonalEffects.delay',
    defaultMessage: 'Delay',
  },
  police: {
    id: 'fastCover.BaggagePersonalEffects.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.BaggagePersonalEffects.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.BaggagePersonalEffects.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.BaggagePersonalEffects.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.BaggagePersonalEffects.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.BaggagePersonalEffects.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.BaggagePersonalEffects.notReported',
    defaultMessage: 'Not Reported',
  },
  descriptionOfItem: {
    id: 'fastCover.BaggagePersonalEffects.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.BaggagePersonalEffects.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.BaggagePersonalEffects.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.BaggagePersonalEffects.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.BaggagePersonalEffects.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.BaggagePersonalEffects.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.BaggagePersonalEffects.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.BaggagePersonalEffects.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.BaggagePersonalEffects.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.BaggagePersonalEffects.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.BaggagePersonalEffects.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.BaggagePersonalEffects.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.BaggagePersonalEffects.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.BaggagePersonalEffects.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.BaggagePersonalEffects.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.BaggagePersonalEffects.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.BaggagePersonalEffects.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.BaggagePersonalEffects.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.BaggagePersonalEffects.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.BaggagePersonalEffects.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.BaggagePersonalEffects.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.BaggagePersonalEffects.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.BaggagePersonalEffects.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.BaggagePersonalEffects.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.BaggagePersonalEffects.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.BaggagePersonalEffects.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.BaggagePersonalEffects.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.BaggagePersonalEffects.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.BaggagePersonalEffects.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.BaggagePersonalEffects.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.BaggagePersonalEffects.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.BaggagePersonalEffects.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.BaggagePersonalEffects.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.BaggagePersonalEffects.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.BaggagePersonalEffects.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.BaggagePersonalEffects.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.BaggagePersonalEffects.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.BaggagePersonalEffects.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  otherInsuranceAuthorization: {
    id: 'fastCover.BaggagePersonalEffects.otherInsuranceAuthorization',
    defaultMessage: 'OTHER INSURANCE / AUTHORISATION:',
  },
  companyName: {
    id: 'fastCover.BaggagePersonalEffects.companyName',
    defaultMessage: 'Company Name',
  },
  typeOfPolicy: {
    id: 'fastCover.BaggagePersonalEffects.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  policy: {
    id: 'fastCover.BaggagePersonalEffects.policy',
    defaultMessage: 'Policy',
  },
  lossInformation: {
    id: 'fastCover.BaggagePersonalEffects.lossInformation',
    defaultMessage: 'Loss Information',
  },
  dateOfLoss: {
    id: 'fastCover.BaggagePersonalEffects.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },
  pleaseDescribeWhatOccurred: {
    id: 'fastCover.BaggagePersonalEffects.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred:',
  },
  placeOfLoss: {
    id: 'fastCover.BaggagePersonalEffects.placeOfLoss',
    defaultMessage: 'Place of Loss:',
  },
  name: {
    id: 'fastCover.BaggagePersonalEffects.name',
    defaultMessage: 'Name',
  },
  address: {
    id: 'fastCover.BaggagePersonalEffects.address',
    defaultMessage: 'Address',
  },
  contact: {
    id: 'fastCover.BaggagePersonalEffects.contactF',
    defaultMessage: 'Contact',
  },
  phone: {
    id: 'fastCover.BaggagePersonalEffects.phone',
    defaultMessage: 'Phone',
  },
  delayInformation: {
    id: 'fastCover.BaggagePersonalEffects.delayInformation',
    defaultMessage: 'Delay Information',
  },
  lossInformationWithIdx: {
    id: 'fastCover.BaggagePersonalEffects.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },
  haveYouReceivedReimbursement: {
    id: 'fastCover.BaggagePersonalEffects.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },
  howMuchReceivedReimbursement: {
    id: 'fastCover.BaggagePersonalEffects.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },
  fromWhom: {
    id: 'fastCover.BaggagePersonalEffects.fromWhom',
    defaultMessage: 'If so, from whom?',
  },
  delayInformationWithIdx: {
    id: 'fastCover.BaggagePersonalEffects.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.BaggagePersonalEffects.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },
  haveYouMadeAClaimWithYourTravelProvider: {
    id: 'fastCover.BaggagePersonalEffects.haveYouMadeAClaimWithYourTravelProvider',
    defaultMessage: 'Have you made a claim with your Travel provider?',
  },
  itemDescription: {
    id: 'fastCover.BaggagePersonalEffects.itemDescription',
    defaultMessage: 'Item Description',
  },
  estimatedValue: {
    id: 'fastCover.BaggagePersonalEffects.estimatedValue',
    defaultMessage: 'Estimated Value',
  },
  scheduledDateOfReturn: {
    id: 'fastCover.BaggagePersonalEffects.scheduledDateOfReturn',
    defaultMessage: 'Scheduled Date of Return',
  },
  scheduledDateOfDeparture: {
    id: 'fastCover.BaggagePersonalEffects.scheduledDateOfDeparture',
    defaultMessage: 'Scheduled Date of Departure',
  },
  areYouClaimingForALostItem: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingForALostItem',
    defaultMessage: 'Are you claiming for lost items?',
  },
  areYouClaimingForValuables: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingForValuables',
    defaultMessage: 'Are you claiming for valuables?',
  },
  areYouClaimingForBaggageDelayPerDay: {
    id: 'fastCover.BaggagePersonalEffects.areYouClaimingForBaggageDelayPerDay',
    defaultMessage: 'Are you claiming for Baggage Delay (Per Day)?',
  },
  cityOrTown: {
    id: 'fastCover.BaggagePersonalEffects.cityOrTown',
    defaultMessage: 'City or Town',
  },
  country: {
    id: 'fastCover.BaggagePersonalEffects.country',
    defaultMessage: 'Country',
  },
  postalCode: {
    id: 'fastCover.BaggagePersonalEffects.postalCode',
    defaultMessage: 'Postal Code',
  },
  dateOfExpenses: {
    id: 'fastCover.BaggagePersonalEffects.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.BaggagePersonalEffects/messages.js